import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { PictureBackgroundPresentation } from './PictureBackgroundPresentation.js';

var PictureBackgroundWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(PictureBackgroundWrapper, _React$Component);

  var _super = _createSuper(PictureBackgroundWrapper);

  function PictureBackgroundWrapper(props) {
    var _this;

    _classCallCheck(this, PictureBackgroundWrapper);

    _this = _super.call(this, props);
    _this.mediaQueryLists = [];

    _this.testWebpSupport = function () {
      var TestImages = {
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
        animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
      };
      var img = new Image();

      img.onload = function () {
        _this.setState({
          webpSupport: img.width > 0 && img.height > 0
        });

        _this.handleMediaQuery();
      };

      img.onerror = function () {
        _this.setState({
          webpSupport: false
        });

        _this.handleMediaQuery();
      };

      img.src = "data:image/webp;base64,".concat(TestImages.alpha);
    };

    _this.addListeners = function () {
      var _a;

      if (typeof window === "undefined") {
        return;
      }

      _this.mediaQueryLists = (_a = _this.props.source) === null || _a === void 0 ? void 0 : _a.map(function (s) {
        var mql = window.matchMedia(s.media || "all");

        if (typeof mql.addEventListener === "function") {
          mql.addEventListener("change", _this.handleMediaQuery);
        } else {
          // TODO test
          mql.addListener(_this.handleMediaQuery);
        }

        return mql;
      });
    };

    _this.removeListeners = function () {
      var _a;

      if (typeof window === "undefined") {
        return;
      }

      (_a = _this.mediaQueryLists) === null || _a === void 0 ? void 0 : _a.map(function (mql) {
        if (typeof mql.removeEventListener === "function") {
          mql.removeEventListener("change", _this.handleMediaQuery);
        } else {
          // TODO test
          mql.removeListener(_this.handleMediaQuery);
        }

        return mql;
      });
    };

    _this.handleMediaQuery = function () {
      _this.setState({
        viewportSource: _this.getViewportSource()
      });
    };

    _this.getViewportSource = function () {
      var _a; // Iterates trough all mediaQueries until the first matches = true.


      var findIndex = (_a = _this.mediaQueryLists) === null || _a === void 0 ? void 0 : _a.findIndex(function (mql, index) {
        if (_this.props.source[index].type === "image/webp" && !_this.state.webpSupport) {
          return false;
        }

        if (mql.matches) {
          return true;
        }

        return false;
      });
      return findIndex === undefined || findIndex < 0 ? _this.props.imgSrc : _this.props.source[findIndex].srcSet;
    };

    _this.state = {
      viewportSource: undefined,
      webpSupport: false
    };
    return _this;
  }

  _createClass(PictureBackgroundWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.testWebpSupport();
      this.addListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _a, _b, _c;

      if (this.props.source !== undefined && (((_a = this.props.source) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = this.mediaQueryLists) === null || _b === void 0 ? void 0 : _b.length) || ((_c = this.props.source) === null || _c === void 0 ? void 0 : _c.some(function (s, i) {
        var _a, _b;

        return ((_b = (_a = prevProps.source) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.media) !== s.media;
      })))) {
        this.removeListeners();
        this.addListeners();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var viewportSource = this.state.viewportSource;
      return /*#__PURE__*/React.createElement(PictureBackgroundPresentation, Object.assign({}, this.props, {
        viewportSource: viewportSource
      }));
    }
  }]);

  return PictureBackgroundWrapper;
}(React.Component);

export { PictureBackgroundWrapper };
